'use strict';

/*global app*/
/*globals blockElement*/
/*globals unBlockElement*/

function BarcodeCheckService() {

  this.init();
}

BarcodeCheckService.prototype = $.extend({}, {
  constructor: 'BarcodeCheckService',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    return _this;
  },

  //----------------------------------------------------------------------------

  checkBarcode: function checkBarcode($wrapper, workplaceRID, barcode, data, callback) {
    var _this = this;

    blockElement($wrapper);
    app.get(app.path('barcode_check', { WorkplaceRID: workplaceRID, Barcode: barcode }), data, function (res) {
      unBlockElement($wrapper);

      if (res.msg === 'SUCCESS') {
        callback(res.data.BarcodeType, res.data);
      } else if (res.msg === 'NOT_VALID') {
        app.viewWarningMessage();
        callback('NotValid');
      } else {
        app.viewErrorMessage(res.error);
        callback('Error');
      }
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  operationBarcode: function operationBarcode(barcode, data) {
    var _this = this;

    location.href = data.Url;

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.registerCallbacks();

    return _this;
  }
});
